define(["./remoteModule"], function (remoteModule) {
    return remoteModule.config(["$httpProvider", function ($httpProvider) {
        $httpProvider.interceptors.push("remoteLogger");
        $httpProvider.interceptors.push("remoteUrlNormalizer");
    }]);
});